export const ChatMessageAssetType = {
  unknown: 0,
  audio: 1,
}
